"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("./RtcCommand");
class DomainCommandHandler {
    constructor(category, logger, cmdHub) {
        this._cmdDic = new Map();
        this._category = category;
        this._logger = logger;
        this._commandHub = cmdHub;
    }
    registerAsyncCommandHandler(cmdName, asyncHandler) {
        this._cmdDic.set(cmdName, asyncHandler);
    }
    handleCommand(rtcCmd) {
        throw new Error("Not Implemented.");
    }
    async handleCommandAsync(rtcCmd) {
        this._logger.debug(`${this._logger.name} Begin Handling ${rtcCmd.category}.${rtcCmd.name}.${rtcCmd.type}`);
        await this.internalProcessCommandAsync(rtcCmd);
        this._logger.debug(`${this._logger.name} End Handling ${rtcCmd.category}.${rtcCmd.name}.${rtcCmd.type}`);
    }
    async internalProcessCommandAsync(rtcCmd) {
        if (rtcCmd.category !== this._category) {
            const error = `Not ${this._category} command = ${rtcCmd}`;
            this._logger.error(error);
            return;
        }
        try {
            await this.matchCommandAsync(rtcCmd);
        }
        catch (error) {
            const resFailCmd = RtcCommand_1.RtcCommand.Builder()
                .Id(rtcCmd.id)
                .CmdTypeAction(RtcCommand_1.CmdType.ResponseFail)
                .Category(rtcCmd.category)
                .Name(rtcCmd.name)
                .Receiver(rtcCmd.sender)
                .TargetId(rtcCmd.targetId)
                .Content(rtcCmd.content)
                .Message(error.Message)
                .Build();
            await this._commandHub.sendCommandAsync(resFailCmd);
            throw error;
        }
    }
    async matchCommandAsync(rtcCmd) {
        const cmdHandler = this._cmdDic.get(rtcCmd.name);
        if (cmdHandler) {
            await cmdHandler(rtcCmd);
        }
        else {
            this._logger.warn(`No handler for ${rtcCmd.category}.${rtcCmd.name}`);
        }
    }
}
exports.DomainCommandHandler = DomainCommandHandler;
//# sourceMappingURL=DomainCommandHandler.js.map